export const company = {
  name: 'OJANNA Ceiling & Drywall Distributors',
  legalName: 'OJANNA Ceiling & Drywall Distributors (Pty) Ltd',
  // Other names people search for — used as schema.org alternateName
  // Most important first (Google site-name guidance); domain as the last fallback.
  alternateNames: ['OJANNA Distributors', 'OJANNA Ceiling and Drywall Distributors', 'ojanna.co.za'],
  tagline: 'Here to make a difference',
  description_short: "The Garden Route's trusted supplier of ceiling materials and drywall systems — based in George, delivering from Plettenberg Bay to Cape Town and into the Klein Karoo. Proudly serving the building industry and the general public.",
  description_long:
    'Ceiling and drywall supplier in George, Western Cape — distributor of ceiling, drywall, insulation and acoustic products. Master distributor for SuperTec, ETEX, Siniat and OWA. Also distributes KNAUF, CAPCO, Casofour, Isover, Gyproc, RhinoROC, Isotherm, Nutec, WoodUpp, Youngman Roofing & Insulation, MecoLadder, Summit, Aerolite, iTe and Swartland. SABISA Accredited (South African Building Interior Systems Association). Led by Niel Kasselman with more than 30 years in the industry and Green Building Council accreditation. Delivery from Plettenberg Bay to Cape Town, into the Klein Karoo (Oudtshoorn and beyond), the Eastern Cape, and national customers throughout SA.',
  phones: [
    { number: '064 531 9070', href: 'tel:0645319070', international: '+27645319070', label: 'Sales' },
    { number: '064 511 2903', href: 'tel:0645112903', international: '+27645112903', label: 'Owner' },
    { number: '061 515 0834', href: 'tel:0615150834', international: '+27615150834', label: 'Accounts' },
  ],
  email: 'info@ojanna.co.za',
  emails: {
    info: 'info@ojanna.co.za',
    admin: 'admin@ojanna.co.za',
    accounts: 'accounts@ojanna.co.za',
  },
  address: {
    line1: '6 Ruby Crescent, Unit 32',
    line2: 'Joubert Industria, Tamsui Industria',
    line3: 'George, South Africa',
    short: 'Joubert Industria, George',
    street: '6 Ruby Crescent, Unit 32, Joubert Industria',
    locality: 'George',
    region: 'Western Cape',
    country: 'ZA',
  },
  geo: {
    latitude: -33.991443,
    longitude: 22.448012,
  },
  // Social / directory profiles (Facebook, Google Business Profile, LinkedIn…) — add URLs here,
  // they are emitted as schema.org sameAs to tie the brand together for search engines.
  sameAs: [],
  mapsUrl: 'https://maps.app.goo.gl/AV2y6Fsv97gZdQFVA',
  mapsEmbed:
    'https://www.google.com/maps/embed?pb=!1m14!1m8!1m3!1d1123.1407197253022!2d22.448012!3d-33.991443!3m2!1i1024!2i768!4f13.1!3m3!1m2!1s0x1dd61b592b136dcd%3A0x496c05bad9c143d5!2sOJANNA%20Distributors%20(Pty)%20Ltd!5e1!3m2!1sen!2sus!4v1771592701716!5m2!1sen!2sus',
  hours: {
    weekdays: '7:30 AM - 4:15 PM',
    friday: '7:30 AM - 2:15 PM',
  },
  // Machine-readable hours for structured data — keep in sync with `hours` above
  // and with the Google Business Profile.
  openingHours: [
    { days: ['Monday', 'Tuesday', 'Wednesday', 'Thursday'], opens: '07:30', closes: '16:15' },
    { days: ['Friday'], opens: '07:30', closes: '14:15' },
  ],
  founder: {
    name: 'Niel Kasselman',
    jobTitle: 'Owner & Green Building Council Professional',
    description:
      'Well-known in the building industry with more than 30 years of experience',
  },
  mission:
    'To deliver the right solution to our customers, empowering them with our three decades of expertise, while ensuring superior service and competitive pricing.',
  vision:
    'To enhance brand recognition within the industry and establish ourselves as the undisputed leader in supply throughout the Garden Route area. We also service and supply national customers throughout South Africa.',
  coreValues: ['Integrity', 'Respect', 'Accountability', 'Safety'],
  accreditation: 'SABISA Accredited',
  testimonials: [
    'You guys are awesome!',
    'Please keep pricing sharp!',
    'Quick response time.',
    'Extremely helpful & knowledgeable',
  ],
  knowledgeAreas: [
    'Ceiling Systems',
    'Exposed Grid Ceilings',
    'Drywall Partitioning',
    'Aluminium Profiles',
    'Insulation',
    'Acoustic Panels',
    'Fibre Cement Boards',
    'Green Building',
    'Steel Brandering',
    'Plasterboard',
    'Plasters',
  ],
  priceRange: '$$',
  // Structured-data service regions; towns come from locations.js (one landing page each)
  areasServed: {
    regions: ['Garden Route', 'Klein Karoo', 'Overberg', 'Western Cape', 'Eastern Cape'],
  },
};
